import {Injectable} from "@angular/core";
import Swal, {SweetAlertResult} from "sweetalert2";

@Injectable()
export class AlertService {
    showSuccess(message, timer = 2000) {
      this.showToast('success', message, timer);
    }

    showDataSaved() {
      this.showSuccess('Dane zapisane poprawnie');
    }

    confirm(title = 'Czy na pewno chcesz usunąć?', text: string = null, confirm = 'Tak'): Promise<SweetAlertResult> {
      return Swal.fire({
        title: title,
        icon: 'warning',
        text: text,
        showCancelButton: true,
        confirmButtonColor: '#0154c8',
        cancelButtonColor: '#d33',
        confirmButtonText: confirm,
        cancelButtonText: 'Nie'
      })
    }

    // Three-way dialog: confirm / deny / cancel. Result carries isConfirmed / isDenied / isDismissed.
    confirmWithDeny(title: string, text: string, confirm: string, deny: string): Promise<SweetAlertResult> {
      return Swal.fire({
        title: title,
        icon: 'warning',
        text: text,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: '#0154c8',
        denyButtonColor: '#691969',
        cancelButtonColor: '#d33',
        confirmButtonText: confirm,
        denyButtonText: deny,
        cancelButtonText: 'Anuluj',
      })
    }

    showError(message) {
      this.showToast('error', message, 4000);
    }

    showGeneralError() {
      this.showToast('error', 'Coś poszło nie tak. Skontakuj się znami mailowo, rozwiążemy problem');
    }

    showToast(type, title, timer = 2000) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: timer,
        title: title,
        icon: type,
        backdrop: false,
      })
    }
}
